import { render, staticRenderFns } from "./ConnectItBit.vue?vue&type=template&id=476b7688&"
import script from "./ConnectItBit.vue?vue&type=script&lang=js&"
export * from "./ConnectItBit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports